(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["vaihtohyvitys-lomake"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.vaihtohyvitys-form').forEach(function (form) {
  var msg = form.querySelector('.vaihtohyvitys-msg');
  var btn = form.querySelector('button[type="submit"]');

  function vhShow(text, isError) {
    if (!msg) return;
    msg.hidden = false;
    msg.textContent = text;
    msg.classList.toggle('alert--error', !!isError);
    msg.classList.toggle('alert--success', !isError);
  }

  form.addEventListener('submit', async function (e) {
    e.preventDefault();
    if (!form.reportValidity()) return;

    var url = form.getAttribute('data-webhook');
    if (!url) { vhShow(msg.dataset.error, true); return; }

    var data = {};
    new FormData(form).forEach(function (value, key) {
      data[key] = typeof value === 'string' ? value.trim() : value;
    });

    // Honeypot: jos piilokenttä on täytetty, kyseessä on botti -> ei lähetetä
    if (data.website) { return; }

    if (!data.etunimi || !data.sukunimi || !data.email || !data.tuote) {
      vhShow(msg.dataset.error, true);
      return;
    }

    if (btn) { btn.disabled = true; }

    try {
      var res = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
      });
      if (!res.ok) throw new Error('Request failed: ' + res.status);
      form.reset();
      if (btn) { btn.style.display = 'none'; }
      vhShow(msg.dataset.success, false);
    } catch (err) {
      if (btn) { btn.disabled = false; }
      vhShow(msg.dataset.error, true);
    }
  });
});

  } catch(e) { console.error(e); }
})();
})();
